<div>
  @if (location$ | async; as machineLocation) {
    <a class="zn-link" target="_blank" [attr.href]="machineLocation.url">{{ 'TOUR.GEOLINK' | translate }}</a>
    <p class="zn-text-size-75" [attr.data-testid]="'machine-location-timestamp'">
      <zenith-icon class="clickable" icon-name="refresh" (click)="findMachine()" />
      {{ 'TOURSTOPACTION.LAST_CARGO_UPDATED_ON' | translate: {date: machineLocation.timestamp | date: 'dd/MM/yyyy HH:mm'} }}
    </p>
  } @else {
    <zenith-button
      zn-type="button"
      zn-icon-name="search"
      (click)="findMachine()"
      [attr.zn-disabled]="loading$ | async">{{ 'TOUR.GEO_BUTTON' | translate }}
    </zenith-button>
  }
</div>
@if (loading$ | async) {
  <zenith-spinner zn-show zn-inline></zenith-spinner>
}
